import React from "react";
import TextInfo from "@/bit/components/components.text";

const PostCard = (props) => {
  const { skeletonClassName } = props;
  return (
        <div className="capta-price--mobile">
          <TextInfo
            className="card-header--title"
            {...props}
            cyData="Card Text-7"
          />
          <div className={`${skeletonClassName} postcard`} />
        </div>
  );
};

export default PostCard;
